import { useAssignments } from "../hooks/useAssignments";
import { Form, Button } from 'react-bootstrap';
import Select from 'react-select';
import '../styles/Assignments.css';
import type { DispatchAssignment, DispatchServiceArea, ReactSelectOption } from "../types/assignment.types";
import dayjs from "dayjs";

type AssignmentSearchProps = {
    getDispatchAssignments: () => void;
    searchWeekStart: string | undefined;
    updateStartDateParam: (date: string) => void;
    searchServiceAreaId: string | undefined;
    serviceAreasData: DispatchServiceArea[];
    updateServiceAreaIdParam: (id: string) => void;
    toggleLoadingCalendar: (loading: boolean) => void;
}

export default function AssignmentSearch(props: AssignmentSearchProps) {
    const { getDispatchAssignments,
        searchServiceAreaId,
        updateStartDateParam,
        serviceAreasData,
        updateServiceAreaIdParam,
        searchWeekStart,
        toggleLoadingCalendar
    } = props; 

    const formatSelectedServiceArea = (): ReactSelectOption | null => {
        const id = searchServiceAreaId ? Number(searchServiceAreaId) : null;
        if (!id) return null;

        const serviceArea = serviceAreasData.find(s => s.ServiceAreaID === id);
        if (!serviceArea) return null;

        return { value: serviceArea.ServiceAreaID.toString(), label: serviceArea.ServiceAreaShortDesc };
    };

    const handleSearchClick = async () => {
        toggleLoadingCalendar(true);
        await getDispatchAssignments();
        toggleLoadingCalendar(false);
    }

    return (
        <div className='dispatch-assignments-search-container'>            
            <div className='dispatch-assignments-search-wrapper'>
                <div style={{width: '300px'}}>
                    <div style={{ color: "white", marginBottom: '0.25rem' }}>Service Area</div>
                    <Select options={
                        serviceAreasData.map((serviceArea) => ({
                            value: serviceArea.ServiceAreaID, label: serviceArea.ServiceAreaLongDesc}))
                        }
                        value={formatSelectedServiceArea()}
                        onChange={(selected: ReactSelectOption) => {
                            updateServiceAreaIdParam(selected.value);
                        }}
                    />
                </div>
                <div>
                    <div style={{ color: "white", marginBottom: '0.25rem' }}>Week Start Date</div>
                    <Form.Control
                        type='date'
                        name='startDate'
                        value={searchWeekStart}
                        onChange={(e) => updateStartDateParam(e.target.value)}
                    />
                </div>                
                <div></div>
                <div className='dispatch-assignments-search-button-wrapper'>
                    <Button onClick={async () => { handleSearchClick(); }} disabled={!searchServiceAreaId || !searchWeekStart}>Search</Button>
                </div>
            </div>
        </div>
    )
}